import React, { Component } from 'react';
import PanelHolder from '../model/PanelHolder.js';
import { listenTo, clearBindings } from '../util/Utility.js';

export default class PaymentsView extends Component {

  constructor(props) {
    super(props);
  }

  fetchObjects(limit, callback) {
    clearBindings();
    listenTo("events", this, callback, {
      orderByChild: 'date',
      limitToLast: limit
    }, e => e.action === "register")
  }

  componentWillUnmount() {
    clearBindings();
  }

  render() {

    return ( <center>
      <PanelHolder type="payments" fetchObjects={this.fetchObjects.bind(this)} {...this.props} />
    </center> );
  }
}



/** WEBPACK FOOTER **
 ** ./src/financial/PaymentsView.js
 **/